// import "./App.css";
import { useRouter } from "next/router";
import { useEffect } from "react";

import useStore from "@/lib/stateManagement/store";

import AddressForm from "./components/AddressForm";
import CheckoutSummary from "./components/CheckoutSummary";
import GiftCardForm from "./components/GiftCardForm";
import Payment from "./components/Payment";
import useChangeLocation from "./hooks/useChangeLocation";
import useLocalCart from "./hooks/useLocalCart";
import useAdyen from "./lib/checkout/payment/useAdyen";
import type { CentraAddress } from "./lib/Selection/formatters";
import useSelection from "./lib/Selection/useSelection";
import type { ConfigSchema } from "./lib/useConfig";
import { useConfig, useInitConfig } from "./lib/useConfig";

export type GiftCardConfig = Partial<ConfigSchema>;
function App(props: {
  config?: string;
  route?: string | string[];
  navigate: (path: string) => void;
}) {
  const router = useRouter();
  const locale = router.locale;
  const { cart } = useLocalCart();

  const config = JSON.parse(props?.config || "{}");

  useInitConfig(config);

  const { config: data } = useConfig();

  const { changeLocation } = useChangeLocation();
  const { location } = useSelection();

  useEffect(() => {
    if (
      data?.centra?.country &&
      location?.country &&
      location?.country !== data?.centra?.country
    ) {
      changeLocation.mutate({
        locationId: data?.centra.country,
      });
    }
  }, [data?.centra?.country, location?.country]);

  const { initPayment, checkoutHTML, checkoutScript, loading } = useAdyen();
  const setPaymentResult = useStore((store) => store.setPaymentResult);

  useEffect(() => {
    setPaymentResult(undefined);
  }, []);
  const navigate = props.navigate;

  const submitCallback = () => {
    //
    // initPayment({
    //   email: values["sender-email"],
    //   country: location?.country,
    //   address1: "test",
    // });
    navigate(`${config?.root}/giftcard/address`);
  };

  const secondCallback = (values: CentraAddress) => {
    initPayment(
      values,
      `${cart.senderName}___${cart.recieverName}___${cart.message}`
    );
    navigate(`${config?.root}/giftcard/payment`);
  };

  return (
    <div className="GiftcardApp">
      {props.route === "success" && <CheckoutSummary locale={locale || "en"} />}
      {props.route === "address" && <AddressForm callback={secondCallback} />}
      {props.route === "payment" && (
        <Payment
          checkoutHTML={checkoutHTML}
          checkoutScript={checkoutScript}
          loading={loading}
        />
      )}
      {props.route === "giftcard" && <GiftCardForm submit={submitCallback} />}
    </div>
  );
}

export default App;
